export default "__VITE_ASSET__DHUiyxvf__";